export const ADMIN = {
	// KEAP VERIFICATION SUCCESS MESSAGES
	keapVerificarionSuccess: "Keap Verification Successfully",
    keapVerificarionIDLE: "Verification IDLE",
    keapVerificarionError: "Keap Verification Error",



};
